import load from "load-script"

import Script from "./script"

class AmazonHeaderBidding extends Script {
  constructor(settings) {
    super(settings)
    window.apstag = {
      _Q: [],
      init: (...args) => {
        window.apstag._Q.push(["i", args])
      },
      fetchBids: (...args) => {
        window.apstag._Q.push(["f", args])
      },
      setDisplayBids: () => {},
      targetingKeys: () => [],
    }
  }

  load() {
    this.configure()
    load("https://c.amazon-adsystem.com/aax2/apstag.js")
  }

  configure() {
    window.apstag.init({
      pubID: "3854",
      adServer: "googletag",
      videoAdServer: "DFP",
      bidTimeout: 1e3,
      deals: true,
    })
  }

  bid(adPositionPairs, callback) {
    const slots = adPositionPairs.map(({ ad, position }) => ({
      slotID: position.id,
      slotName: ad.unitPath,
      sizes: ad.getSizes(),
    }))

    window.apstag.fetchBids({ slots }, (bids) => {
      callback(bids)
    })
  }

  bidVideo(_callback) {
    window.apstag.fetchBids(
      {
        slots: [
          {
            slotID: "videoSlot",
            mediaType: "video",
          },
        ],
      },
      (bids) => {
        this._debugger("amazon-hb", "videoBids: ", bids)
        let vastParams = ""
        let videoBid = bids.filter(function (bid) {
          return bid.mediaType === "video"
        })[0]
        if (videoBid) {
          // don't uri encode vastParams: Viralize js will do it
          vastParams = videoBid.helpers.qsParams()
          this._debugger("amazon-hb", "vastParams: ", vastParams)
        }
        return _callback(vastParams)
      }
    )
  }

  setTargeting() {
    window.apstag.setDisplayBids()
  }
}

export default AmazonHeaderBidding
